import { BehaviorSubject, Observable } from 'rxjs';

import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({ standalone: false, selector: '[adsptStepWizardStep]' })
export class StepWizardStepDirective {
  @Input('adsptStepWizardStepTitle')
  title?: string;

  @Input('adsptStepWizardStepHeader')
  header?: string;

  @Input('adsptStepWizardStepPrimaryButton')
  primaryButton?: string;

  @Input('adsptStepWizardStepUseTitleAsHeader')
  useTitleAsHeader?: boolean;

  @Input('adsptStepWizardStepCanContinue')
  canContinue?: boolean;

  @Input('adsptStepWizardStepFinal')
  final?: boolean;

  @Input('adsptStepWizardStepMaxWidth')
  maxWidth?: number;

  @Input('adsptStepWizardStepAssertContinue')
  assertContinue?: () => Observable<boolean>;

  readonly sideStep$ = new BehaviorSubject<TemplateRef<any> | undefined>(void 0);

  constructor(readonly tr: TemplateRef<any>) {}
}
